import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

import './style.scss';

const HiddenInput = ({ prefix, postfix, canChange, value, min, max, onChange }) => {
  const [input, setInput] = useState(value);
  const [errors, setErrors] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    setInput(value);
  }, [value]);

  const handleChange = ({ target: { value } }) => {
    if (errors) {
      setErrors(false);
    }

    setInput(value);
  };

  const handleBlur = () => {
    if (min && input < min) {
      setErrors(true);
      return;
    }

    if (max && input > max) {
      setErrors(true);
      return;
    }

    setOpen(false);
    onChange(+input);
  };

  const handleClick = (e) => {
    if (canChange) {
      e.stopPropagation();
      !open && setOpen(true);
    }
  };

  if (!open) {
    return (
      <div onClick={handleClick}>
        {prefix}
        {value}
        {postfix}
      </div>
    );
  }

  const errorBorder = errors && { border: '1px solid red' };

  return (
    <input
      className="hidden-input"
      value={input}
      style={errorBorder || {}}
      onClick={handleClick}
      onChange={handleChange}
      onBlur={handleBlur}
      type="number"
    />
  );
};

HiddenInput.propTypes = {
  canChange: PropTypes.bool,
  min: PropTypes.number,
  max: PropTypes.number,
  value: PropTypes.number.isRequired,
  onChange: PropTypes.func,
  prefix: PropTypes.string,
  postfix: PropTypes.string,
};

HiddenInput.defaultProps = {
  canChange: false,
  onChange: () => {},
  min: null,
  max: null,
  prefix: '',
  postfix: '',
};

export { HiddenInput };
